export default function PHP_Superglobals() {
  return (
    <div>
      <h1>PHP_Superglobals</h1>
    </div>
  );
}
